import React from 'react';

const AuthError = () => {
  return <span>{'Une erreur est survenue lors de la tentative d\'authentification, veuillez réessayer.'}</span>;
};

export default AuthError;
